import { QuestionnaireType } from "@green0meter/api-client";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";
import { Typography } from "@mui/material";

import { useGetCsobFormsMetadata } from "@api";
import { useUserStore } from "@store/user";
import { useCsobQuestionnaireStore } from "@components/main/csob/hub";
import Box from "@components/base/Box/Box";
import { Alert, Stack } from "@components/base";

interface ExistingAssetWarning {
  onClose: () => void;
  isEdit?: boolean;
}

const ExistingAssetWarning: FC<ExistingAssetWarning> = ({ onClose, isEdit }) => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { availableFormsMetadata } = useGetCsobFormsMetadata(user);
  const { shakeTable } = useCsobQuestionnaireStore();
  const hasAssetForms = useMemo(() => {
    return availableFormsMetadata
      ? availableFormsMetadata.some(
          (form) =>
            form.questionnaireType === QuestionnaireType.EnergyAsset ||
            form.questionnaireType === QuestionnaireType.CommercialRealityAsset,
        )
      : false;
  }, [availableFormsMetadata]);

  const handleExistingAssset = (): void => {
    onClose();
    shakeTable();
  };

  return (
    hasAssetForms &&
    !isEdit && (
      <Box mt={3}>
        <Alert
          severity="warning"
          variant="outlined"
          onClick={handleExistingAssset}
          sx={{ cursor: "pointer" }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography color="warning.main">
              {t("csob.assetQuestionnaire.existingAssetFormWarning")}
              &nbsp;
              <a style={{ fontWeight: "bold" }}>
                {t("csob.assetQuestionnaire.seeTable")}
              </a>
            </Typography>
            <FeatherIcon icon="corner-right-down" size={48} />
          </Stack>
        </Alert>
      </Box>
    )
  );
};

export default ExistingAssetWarning;
